var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header'),_c('div',{staticClass:"container d-flex justify-content-center"},[_c('UserLoginForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }